import { useEffect, useState } from "react";

import Header from "../../components/Header";
import Card from "../../components/Card";
import { useGetFeedsMutation } from "../../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../../features/auth/authSlice";
import { useLocation } from "react-router-dom";

const Index = () => {
  const [feeds, setFeeds] = useState([] as any);
  const [getFeeds] = useGetFeedsMutation();
  const sponserId = useSelector(selectSponserID);
  const location = useLocation();
  const feedData = location.state;

  useEffect(() => {
    if (location.state !== null) {
      setFeeds([feedData.feedId]);
    } else {
      const getFeedsOfCreators = async () => {
        const response: any = await getFeeds({ sponserId: sponserId }).unwrap();
        setFeeds(response?.feeds);
      };
      getFeedsOfCreators();
    }
  }, [feedData, getFeeds, location.state, sponserId]);

  return (
    <div className="ml-5 mt-[100px]">
      <Header title="Feeds" subtitle="Sponsers feeds." />
      <div className="flex flex-wrap">
        {feeds.map((feed: any) => {
          return (
            <Card
              key={feed._id}
              content={feed.content}
              creator={feed.creator}
              imageUrl={feed.imageUrl}
              title={feed.title}
              price={feed.price}
              proposals={feed.proposals}
              feedId={feed._id}
              setFeeds={setFeeds}
              createdAt={feed.createdAt}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Index;
